import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';
import { MatrixConfigurationResponseSchema } from '@repo/contracts';

export class MatrixConfigurationService {
    constructor(api, config = {}) {
        this.api = api;
        this.config = config;
    }

    async getMatrixConfiguration() {
        try {
            const response = await withRetry(
                () => this.api.getMatrixConfiguration(),
                { maxRetries: 2 },
            );

            const validated = MatrixConfigurationResponseSchema.parse(response);

            return {
                success: true,
                data: validated.data,
                message: validated.message || 'Matrix yapılandırması getirildi',
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch matrix-configuration');
        }
    }

    async updateMatrixConfiguration(data) {
        try {
            const response = await this.api.updateMatrixConfiguration(data);

            const validated = MatrixConfigurationResponseSchema.parse(response);

            return {
                success: true,
                data: validated.data,
                message: validated.message || 'Matrix yapılandırması güncellendi',
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to update matrix-configuration');
        }
    }

    /** Compatibility alias used by legacy callers */
    async getAll(params = {}) {
        return this.getMatrixConfiguration();
    }

    _handleError(error, defaultMessage) {
        if (error instanceof ApiError) {
            throw error;
        }

        if (error.statusCode || error.status) {
            throw ApiError.fromResponse(error);
        }

        throw new ApiError(error.message || defaultMessage, 500, 'UNKNOWN_ERROR', error);
    }
}
